export const DISCOVER_FILTERS = 'DISCOVER_FILTERS';

export const discoverFilters = (discoverFilters) => {
    return {
        type: DISCOVER_FILTERS,
        payload: discoverFilters
    }

}